import React from "react"
import Layout from "../../components/layout/baseLayout"
import SEO from "../../components/seo"
import Typeform from "../../components/Typeform"
export default function iwd() {
  return (
    <Layout>
      <SEO title="Register"></SEO>
      <Typeform url="https://nassim780857.typeform.com/to/l7LmVV"></Typeform>
    </Layout>
  )
}
